import m from "../../geodata/es2015/chileHigh";
window.am4geodata_chileHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/chileHigh.js
// module id = null
// module chunks = 